<template>
    <div>
        <g-typography class="g-mb-3" tag="h3" font-weight="semibold" value="Delivered content" />

        <g-typography tag="p" class="g-mb-6">
            <span v-if="authenticated" data-testid="authed-text">
                This includes content automatically delivered after connecting (authenticating) your account.
            </span>
            <span v-else data-testid="unauthed-text">
                If you connect your social accounts, this includes content automatically delivered after connecting
                (authenticating) your account.
            </span>
        </g-typography>

        <g-typography
            class="g-mb-3"
            tag="p"
            size="small"
            color="grey-6"
            :value="`Total deliverables ${quantityString}`"
        />

        <g-loader v-if="isLoading" />
        <div v-else>
            <div v-if="hasContent" data-testid="task-content">
                <activation-content
                    v-for="content in taskContent"
                    :key="content.id"
                    :type="task.type"
                    :url="content.content.url"
                    :thumbnail="getThumbnail(task, content)"
                    :date="content.created_at"
                    :content-id="content.id"
                    :network-id="content.network_id"
                    class="g-mb-5"
                />
            </div>
            <g-base-box v-else background-color="grey-2" :border="false">
                <g-typography tag="p" size="small" color="grey-6" value="No content delivered yet" />
            </g-base-box>
        </div>
    </div>
</template>

<script>
    import { computed, toRefs } from 'vue-demi';
    import ActivationContent from '../../../../library/ActivationContent.vue';
    import { getThumbnail } from '../../../../../helpers/activations/content-thumbnail';

    export default {
        name: 'ActivationContentList',
        methods: { getThumbnail },

        components: { ActivationContent },

        props: {
            isLoading: {
                type: Boolean,
                default: false
            },
            authenticated: {
                type: Boolean,
                default: false
            },
            task: {
                type: Object,
                default: () => {}
            },
            taskContent: {
                type: Array,
                default: () => []
            },
            quantityString: {
                type: String,
                default: ''
            }
        },

        setup(props) {
            const { taskContent } = toRefs(props);

            const hasContent = computed(() => taskContent.value?.length > 0 || false);

            return {
                hasContent
            };
        }
    };
</script>
